export const errorMap = {
  'access token required': 'Please refresh the page and try again',
};
